/**
 * D5b: React hook for fetching the client list from lexserver.
 *
 * Used by the Workspace panel tree (D6) as the top-level data source.
 * Backed by TanStack Query for caching + refetch + error handling.
 * The query key is `["clients"]` — the current caller's orgId is
 * resolved from the auth token inside `fetchClients`, so it does not
 * need to be part of the key.
 */

import { useQuery } from "@tanstack/react-query";
import { fetchClients, type ClientListItem } from "@/lib/lexserver-client";

export function useClients() {
  return useQuery<ClientListItem[], Error>({
    queryKey: ["clients"],
    queryFn: fetchClients,
    staleTime: 60_000, // 1 minute
    retry: 2,
  });
}
